export enum Gender {
  Male = 0,
  Female = 1,
  Unknown = 2,
  Other = 3,
}

export enum InvoicePreference {
  Email = 1,
  Paper = 2,
  Both = 3,
}

export enum CardCreationType {
  Link = 0,
  Create = 1,
}

export enum CardType {
  Virtual = 0,
  Physical = 1,
}
